import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
    selector: 'app-editable-list',
    standalone: true,
    imports: [InputTextModule, ButtonModule, TooltipModule, TranslatePipe],
    templateUrl: './editable-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditableListComponent {
    @Input() items: any[] = [];
    @Input() labelKey = 'skillName';
    @Input() ratingKey = 'rating';
    @Input() defaultRating = 5;
    @Input() maxRating = 5;
    @Input() searchPlaceholder = 'Search';
    @Input() addButtonLabel = 'default-cm-addSkill';
    @Input() addButtonDefault = 'Add Skill';
    @Input() showAddButton = true;

    @Output() editClick = new EventEmitter<any>();
    @Output() deleteClick = new EventEmitter<any>();
    @Output() addClick = new EventEmitter<void>();
    @Output() searchChange = new EventEmitter<string>();

    searchTerm = '';

    onSearch(event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        this.searchTerm = value;
        this.searchChange.emit(value);
    }

    getDisplayLabel(item: any): string {
        const label = item[this.labelKey] || item;
        const rating = item[this.ratingKey] ?? this.defaultRating;
        return `${label} (${rating}/${this.maxRating})`;
    }
}
